import { useEffect, useState } from "react";

import AutoComplete from "../elements/AutoComplete";

const LocationStatusSelect = ({ value, onChange }) => {
  const [options, setOptions] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const options = [
      { key: "open", id: "open", name: "Open" },
      { key: "closed", id: "closed", name: "Closed" },
    ];

    setOptions(options);
  };

  const handleChange = (newValue) => {
    // console.log({ newValue });
    onChange(newValue);
  };

  if (!options) return null;

  return (
    <AutoComplete
      id={"locationStatus"}
      label={"Status"}
      value={value || ""}
      onChange={(newValue) => handleChange(newValue)}
      items={options}
    />
  );
};

export default LocationStatusSelect;
